/**
 *  ToggleButton script file
**/

export default {
  name: 'ToggleButton',
  mixins: [],
  components: {},
  props: {
    buttons: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'text',
      required: false,
      validator (value) {
        const options = [
          'text',
          'icon',
          'icon-text',
          'text-icon'
        ]
        return options.indexOf(value) !== -1
      }
    },
    size: {
      type: String,
      default: 'default',
      required: false,
      validator (value) {
        const options = [
          'small',
          'default',
          'large'
        ]
        return options.indexOf(value) !== -1
      }
    },
    colors: {
      type: Object,
      required: true
    },
    spacer: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      activeButton: undefined,
      windowWidth: 0
    }
  },
  created () {
    this.activeButton = this.buttons.find(button => button.active).id

    window.addEventListener('resize', this.resize, false)
  },
  mounted () {
    this.resize()
  },
  computed: {
  },
  methods: {
    selectButton (selected) {
      this.activeButton = selected.id || null
      this.$emit('select', selected)
    },
    setActive (id) {
      this.activeButton = id
    },
    resize () {
      this.windowWidth = window.innerWidth
    }
  }
}
